import React, { useEffect, useState } from "react";
import { Toast, OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "../../seller-apis/api";
import { approvedProducts } from "../../seller-apis/apidataField";
import ProductCard from "../common/ProductCard";
import PaginationCom from "../common/Pagination";
import "../inventry.css";
import { useAlert } from "react-alert";
import { NavLink } from "react-router-dom";
import { variables } from "../../Variables.json";
var globalFilter = {
  pageNo: 1,
  prStatus: {
    prSts: { $exists: false },
  },
  status: {
    vActive: "ACTIVE",
  },
};
function NewOfferPrice() {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();

  // Size states

  const [currView, setcurrView] = useState();
  const [approvedProductsList, setapprovedProductsList] = useState([]);
  const [appRecords, setappRecords] = useState();

  // Pagination related

  const [selectedPage, setselectedPage] = useState(1);
  const [compforPaginationweb, setcompforPaginationweb] =
    useState("approvedPro");
    const [searchType, setSearchType] = useState("Product Name");

  // Loader state

  const [loaderProduct, setloaderProduct] = useState("block");

  // Toast

  const [showToast, setshowToast] = useState(false);
  const [ToastMsg, setToastMsg] = useState();

  // Web search

  const [searchPro, setsearchPro] = useState();

  const [removeFilterClass, setremoveFilterClass] = useState(
    "invent_remove_filter_btn"
  );

  useEffect(() => {
    globalFilter = {
      pageNo: 1,
      prStatus: {
        prSts: { $exists: false },
      },
      status: {
        vActive: "ACTIVE",
      },
    };
    // Approved Products
    api.product
      .productsRetrieveall(approvedProducts(globalFilter))
      .then((res) => {
        console.log(res);
        setapprovedProductsList(res.products);
        setappRecords(res.totalRecords);
        setloaderProduct("none");
      })
      .catch((err) => {
        setloaderProduct("none");
        console.log(err);
      });
  }, []);

  // Pagination function

  function paginate(data) {
    applyLoader();
    globalFilter.pageNo = data.number;
    setselectedPage(data.number);

    // Approved Products
    api.product
      .productsRetrieveall(approvedProducts(globalFilter))
      .then((res) => {
        setapprovedProductsList(res.products);
        removeLoader();
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
  }

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("orDeskContain");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setloaderProduct("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setloaderProduct("none");
    outerdiv.classList.remove("div-bk");
  }

  // search product btn web

  function searchProdBtnweb() {
    if (searchPro !== undefined && searchPro !== "") {
      globalFilter.filters = {
        ...globalFilter.filters,
        productName: searchPro,
      };
      applyLoader();
      setselectedPage(1);
      setcompforPaginationweb("appsearchPro");
      globalFilter.pageNo = "1";
      api.product
        .productsRetrieveall(approvedProducts(globalFilter))
        .then((res) => {
          setremoveFilterClass("invent_remove_filter_btn_active");
          setapprovedProductsList(res.products);
          setappRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else if (compforPaginationweb !== "approvedPro") {
      applyLoader();
      globalFilter.pageNo = "1";
      outerdiv.classList.add("div-bk");
      loaderDiv.classList.add("loader-bt");
      globalFilter.filters = {};
      setselectedPage(1);
      api.product
        .productsRetrieveall(approvedProducts(globalFilter))
        .then((res) => {
          setcompforPaginationweb("approvedPro");
          removeLoader();
          setremoveFilterClass("invent_remove_filter_btn");
          setapprovedProductsList(res.products);
          setappRecords(res.totalRecords);
        })
        .catch((err) => console.log(err));
    }
  }

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
  }

  window.addEventListener("resize", handleResize);

  // Search on enter web

  function checkevent(e) {
    if (e.keyCode === 13) {
      let outerdiv = document.getElementById("orDeskContain");
      let loaderDiv = document.getElementById("enNewLoader");

      if (searchPro !== "" && searchPro !== undefined) {
        let ordersearchFilter=searchType!='sku'?{"productName": searchPro}:{"SKU": searchPro};
        globalFilter.filters = {
          // ...globalFilter.filters,
          ...ordersearchFilter
        };
        applyLoader();
        setselectedPage(1);
        setcompforPaginationweb("appsearchPro");
        globalFilter.pageNo = "1";
        api.product
          .productsRetrieveall(approvedProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn_active");
            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            removeLoader();
            console.log(err);
          });
      } else if (compforPaginationweb !== "approvedPro") {
        console.log("dj");
        applyLoader();
        globalFilter.pageNo = "1";
        outerdiv.classList.add("div-bk");
        loaderDiv.classList.add("loader-bt");
        globalFilter.filters = {};
        setselectedPage(1);
        api.product
          .productsRetrieveall(approvedProducts(globalFilter))
          .then((res) => {
            setremoveFilterClass("invent_remove_filter_btn");
            setcompforPaginationweb("approvedPro");
            removeLoader();
            setapprovedProductsList(res.products);
            setappRecords(res.totalRecords);
          })
          .catch((err) => console.log(err));
      }
    }
  }

  // Clear Filters

  function clearFilters() {
    if (compforPaginationweb !== "approvedPro") {
      applyLoader();
      setselectedPage(1);
      globalFilter = {
        pageNo: "1",
        prStatus: {
          prSts: { $exists: false },
        },
        status: {
          vActive: "ACTIVE",
        },
      };
      setsearchPro("");
      setcompforPaginationweb("approvedPro");
      api.product
        .productsRetrieveall(approvedProducts(globalFilter))
        .then((res) => {
          setapprovedProductsList(res.products);
          setremoveFilterClass("invent_remove_filter_btn");
          setappRecords(res.totalRecords);
          if (res.totalRecords < 1) {
            alert.info("No Records Found");
          }
          removeLoader();
        })
        .catch((err) => console.log(err));
    }
  }
  return (
    <>
      <div className="inventry-page" id="outer">
        <div className="pro_filt_cntnier_price_ver d-flex">
          {/* <button className={removeFilterClass} onClick={() => clearFilters()}>
            Clear Filter
          </button> */}
          <div class="">
                      <select className="pro_approved_srch_bar pr-4" onChange={(e)=>{setSearchType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
          <input
            type="text"
            placeholder="Search for products..."
            className="pro_approved_srch_bar pr-4"
            value={searchPro}
            onKeyUp={(e) => checkevent(e, "appPro")}
            onChange={(e) => setsearchPro(e.target.value)}
          ></input>
          <i
            className="fa fa-search srch_pro_filt_invent"
            aria-hidden="true"
            onClick={() => searchProdBtnweb()}
          ></i>
          <NavLink exact to="/add-Product">
            <button className="pro_add_pro_invent ms-2">+ Add Product</button>
          </NavLink>
        </div>

        <div className="container_invent" id="orDeskContain">
          <div class="tab">
            <table className="ord_table" style={{ width: "100%" }}>
              <thead>
                <tr className="table_ord_title_row">
                  <th className="thead_title pt-2 pb-2" style={{ width: "5%" }}>
                    Product Image
                  </th>

                  <th className="thead_title pb-1" style={{ width: "20%" }}>
                    Product Name<br></br>
                  </th>

                  <th className="thead_title" style={{ width: "10%" }}>
                    Product Status
                  </th>

                  <th className="thead_title" style={{ width: "7%" }}>
                    Transfer price{" "}
                    <OverlayTrigger
                      key="transfer"
                      placement="bottom"
                      overlay={
                        <Tooltip
                          id={`tooltip-transfer`}
                          className="fs-10 order_page_tooltip"
                        >
                          <p className="fs-8 f-500 order_page_tooltip_1">
                            {variables.transferPriceText}
                          </p>
                        </Tooltip>
                      }
                    >
                      <i class="bi bi-info-circle ms-1"></i>
                    </OverlayTrigger>
                  </th>

                  <th className="thead_title" style={{ width: "10%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {appRecords > 0 ? (
                  approvedProductsList.map((item, index) => {
                    let baseImg;
                    let lowestPrice = undefined;
                    let taxClass;
                    item.images.map((item) => {
                      if (item.baseImage === true) {
                        if (item.image.startsWith("products")) {
                          baseImg = item.image;
                        } else if (item.image.startsWith("mob")) {
                          baseImg = item.image;
                        } else {
                          let img = item.image.substr("41");
                          baseImg = img;
                        }
                      }
                    });
                    if (
                      item.vendors[0] &&
                      item.vendors[0].taxClass &&
                      item.vendors[0].taxClass !== ""
                    ) {
                      taxClass = item.vendors[0].taxClass;
                    } else {
                      taxClass = item.taxClass;
                    }
                    let date = new Date(item.vendors[0].updated_at);
                    let d = date.toUTCString(item.vendors[0].updated_at);
                    let newd = d.substr(4, 12);

                    if (item.combination) {
                      let vendorfirstComb = [];

                      if (item.vendors[0].combination.length > 0) {
                        var offerArry = [];
                        var combarry = [];
                        var singleAttr = true;
                        if (
                          item.combination[0] &&
                          item.combination[0].value &&
                          item.combination[0].value.length > 1
                        ) {
                          singleAttr = false;
                        }

                        item.vendors[0].combination.map((vitem, vindex) => {
                          item.combination.map((pitem, pindex) => {
                            if (
                              pitem.url === vitem.url &&
                              vitem.purchase_price &&
                              vitem.purchase_price !== undefined &&
                              pitem.active
                            ) {
                              if (vindex === 0) {
                                if (pitem.lowestPrice < vitem.purchase_price)
                                  lowestPrice = pitem.lowestPrice;
                              }
                              if (!singleAttr) {
                                let com = "";

                                pitem.value.map((aitem, aindex) => {
                                  com = com + aitem;
                                  if (aindex !== pitem.value.length - 1) {
                                    com = com + " x ";
                                  }
                                });
                                combarry.push({
                                  com: com,
                                  price: vitem.purchase_price,
                                  lowestPrice: pitem.lowestPrice,
                                  status:
                                    vitem.vActive === "ACTIVE" ||
                                    vitem.vActive === "INACTIVE_REQ"
                                      ? "In Stock"
                                      : "Out of Stock",
                                  url: vitem.url,
                                });
                                if (
                                  vitem.prSts &&
                                  vitem.prSts === "V_PENDING"
                                ) {
                                  let cmb = "";
                                  pitem.value.map((litem, lindex) => {
                                    cmb = cmb + litem;
                                    if (lindex !== pitem.value.length - 1) {
                                      cmb = cmb + " x ";
                                    }
                                  });
                                  offerArry.push({ cmb: cmb, url: vitem.url });
                                }
                              } else {
                                let com = {
                                  com: pitem.value[0],
                                  price: vitem.purchase_price,
                                  lowestPrice: pitem.lowestPrice,
                                  status:
                                    vitem.vActive === "ACTIVE" ||
                                    vitem.vActive === "INACTIVE_REQ"
                                      ? "In Stock"
                                      : "Out of Stock",
                                  url: vitem.url,
                                };
                                combarry.push(com);
                                if (
                                  vitem.prSts &&
                                  vitem.prSts === "V_PENDING"
                                ) {
                                  offerArry.push({
                                    cmb: pitem.value[0],
                                    url: vitem.url,
                                  });
                                }
                              }
                            }
                          });
                        });
                        console.log(offerArry);
                        return (
                          <ProductCard
                            id={index}
                            taxClass={taxClass}
                            SKU={item.SKU}
                            updatedon={newd}
                            // defUrl={defUrl}
                            urlKey={item.urlKey}
                            lowestPrice={lowestPrice}
                            shortDescription={item.shortDescription}
                            lead={item._id}
                            productName={item.productName}
                            // price={firstPrice}
                            quantity={item.vendors[0].stock}
                            status={item.vendors[0].vActive}
                            weight={item.vendors[0].weight}
                            requestFrom="inventory"
                            offerForArr={offerArry}
                            vendActive={item.vendors[0].active}
                            image={baseImg}
                            vendor={item.vendors[0]}
                            vendorfirstComb={vendorfirstComb}
                            combination={combarry}
                            spcl="actionsTab"
                          />
                        );
                      } else {
                        return (
                          <ProductCard
                            id={index}
                            taxClass={taxClass}
                            SKU={item.SKU}
                            updatedon={newd}
                            urlKey={item.urlKey}
                            lowestPrice={item.lowestPrice}
                            shortDescription={item.shortDescription}
                            lead={item._id}
                            productName={item.productName}
                            price={item.vendors[0].purchase_price}
                            quantity={item.vendors[0].stock}
                            status={item.vendors[0].vActive}
                            vendActive={item.vendors[0].active}
                            vendor={item.vendors[0]}
                            weight={item.vendors[0].weight}
                            requestFrom="inventory"
                            image={baseImg}
                            spcl="actionsTab"
                          />
                        );
                      }
                    } else {
                      return (
                        <ProductCard
                          id={index}
                          taxClass={taxClass}
                          SKU={item.SKU}
                          updatedon={newd}
                          urlKey={item.urlKey}
                          lowestPrice={item.lowestPrice}
                          shortDescription={item.shortDescription}
                          lead={item._id}
                          productName={item.productName}
                          price={item.vendors[0].purchase_price}
                          vendor={item.vendors[0]}
                          quantity={item.vendors[0].stock}
                          status={item.vendors[0].vActive}
                          weight={item.vendors[0].weight}
                          vendActive={item.vendors[0].active}
                          requestFrom="inventory"
                          image={baseImg}
                          spcl="actionsTab"
                        />
                      );
                    }
                  })
                ) : loaderProduct === "block" ? (
                  <></>
                ) : (
                  <></>
                )}
              </tbody>
            </table>
            {/* </Container> */}
          </div>

          <PaginationCom
            number={appRecords}
            paginate={paginate}
            activ={selectedPage}
            comp={compforPaginationweb}
          />

          <div class="d-flex justify-content-center loader-bt" id="enNewLoader">
            <div
              class="spinner-border"
              role="status"
              style={{ display: loaderProduct }}
            >
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
      </div>
      {/* Toast */}
      <Toast
        show={showToast}
        className="ToastHome"
        onClose={() => setshowToast(false)}
      >
        <Toast.Header>
          <strong className="me-auto">Message</strong>
        </Toast.Header>
        <Toast.Body>{ToastMsg}</Toast.Body>
      </Toast>
    </>
  );
}

export default NewOfferPrice;
